import { render } from "./UserContact.vue?vue&type=template&id=3f6a0a6e"
import script from "./UserContact.vue?vue&type=script&lang=js"
export * from "./UserContact.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__